import React, {createRef, useEffect, useRef, useState} from 'react';
import './button.css'
import {findDOMNode} from "react-dom";
import useIsMountedRef from "../../utils/mountedRef";


const ButtonCessionFDC = (props) => {
    const [selectedValue, setSelectedValue] = useState(null);
    const isMountedRef = useIsMountedRef();
    const refYes = createRef();
    const refNo = createRef();
    const refUndefined = createRef();
    let [currentRef, setCurrentRef] = useState(null)

    function EventClick(refPassed, value) {

        refPassed.current.classList.remove("item_no_selected");

        if (refPassed !== refYes) {
            refYes.current.classList.remove('item_selected')
            refYes.current.classList.add('item_no_selected')
        }

        if (refPassed !== refNo) {
            refNo.current.classList.remove('item_selected')
            refNo.current.classList.add('item_no_selected')
        }

        if (props.fieldUndefined && refPassed !== refUndefined) {
            refUndefined.current.classList.remove('item_selected')
            refUndefined.current.classList.add('item_no_selected')
        }

        refPassed.current.classList.add('item_selected')

        setCurrentRef(refPassed);
        setSelectedValue(value);      
        refPassed.current.focus();
        props.handleChange(props.setter, value) // launch handleChange in parent simu
    }
    const handleKeyDown = (e, currentIndex) => {
    const buttons = props.fieldUndefined
        ? [refYes, refNo, refUndefined]
        : [refYes, refNo];

        if (e.key === "ArrowRight") {
            e.preventDefault();
            if (currentIndex < buttons.length - 1) {
                const next = buttons[currentIndex + 1];
                next.current.focus();
                EventClick(next, parseInt(next.current.dataset.value));
            }
        } 
        else if (e.key === "ArrowLeft") {
            e.preventDefault();
            if (currentIndex > 0) {
                const prev = buttons[currentIndex - 1];
                prev.current.focus();
                EventClick(prev, parseInt(prev.current.dataset.value));
            }
        }
    };


    useEffect(() => {
        switch (props.defaultValue) {
            case 2:
                EventClick(refUndefined, 2);
                break;
            case 1:
                EventClick(refYes, 1);
                break;
            case 0:
                EventClick(refNo, 0);
                break;
            default:
                break;
        }
    }, [isMountedRef]);

    return (
        <div className={"item_ctn"}>
           <button data-value="1" type="button" className={"droitpartage item_no_selected"} ref={refYes} 
           tabIndex={selectedValue === 1 ? 0 : -1}
           onClick={() => {
                EventClick(refYes, 1)
            }}
            onKeyDown={(e) => handleKeyDown(e, 0)}
            >
                Régime spécial
            </button>

            <button data-value="0" type="button" className={"droitpartage item_no_selected"} ref={refNo} 
            tabIndex={selectedValue === 0 ? 0 : -1}
            onClick={() => {
                EventClick(refNo, 0)
            }}
            onKeyDown={(e) => handleKeyDown(e, 1)}>
                Régime droit commun
            </button>

            {
                props.fieldUndefined ?
                    <button data-value="2" type="button" className={"common item_no_selected item_large"} ref={refUndefined}
                        tabIndex={selectedValue === 2 ? 0 : -1}
                        onClick={() => {
                             EventClick(refUndefined, 2)
                         }}
                         onKeyDown={(e) => handleKeyDown(e, 2)}>
                        Indéterminé
                    </button>
                    :
                    <></>
            }
        </div>
    );
};

export default ButtonCessionFDC;
